import { React, useState, useEffect } from 'react';
import '../../App.css'
import { Grid, Box, Button, Paper, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography } from '@mui/material';
import { Addchart } from '@mui/icons-material';
import * as yearList from '../../services/yearList';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

const yearOptions = yearList.getYearList();

const today = new Date();
const currentYear = today.getFullYear().toString();

const initialFValues = {
  id: 0,
  month: '',
  year: currentYear
}

function WFStatementReport() {

  const [welfareFundDetail, setWelfareFundDetail] = useState({});
  const [wfMonths, setWfMonths] = useState([]);
  const [empDetails, setEmpDetails] = useState([]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/report/get-wf-months`)
      .then((response) => {
        if (response?.data && response?.data?.data) {
          setWfMonths(response?.data?.data);
        } else {
          setWfMonths([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching WF months:', error);
        
        let errorMessage = 'Failed to fetch welfare fund months';
        
        if (error?.response?.status === 401) {
          errorMessage = 'Company not found. Please select a company.';
        } else if (error?.response?.status === 422) {
          errorMessage = error?.response?.data?.error_message || 'Data processing error';
        } else if (error?.response?.data?.error_message) {
          errorMessage = error?.response?.data?.error_message;
        }
        
        setWfMonths([]);
        
        setNotify({
          isOpen: true,
          message: errorMessage,
          type: 'error'
        });
      });
  }, []);
  
  const validate = () => {
    let temp = {}
    temp.month = values.month.length != 0 ? "" : "This field is required."
    temp.year = values.year.length != 0 ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/report/wf-report-details`, values)
        .then((response => {
          setEmpDetails(response.data);
          navigate('/wf-report', { state: { empDetails: response.data} });
        }))
        .catch((error) => {
        })
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
      <Paper elevation={5} sx={{ width: "1000px", height: "210px" }}>
        <Grid className="form-title" container spacing={2} justifyContent="center" style={{ marginTop: "15px" }} alignItems="center">
          <Grid item> <Addchart sx={{ width: 45, height: 45 }} /> </Grid>
          <Grid item> <Typography variant="h5">Welfare Fund Statement Report</Typography> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Box sx={{ margin: "30px" }}>
            {/* All elements in one line */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}>

              {/* Month field */}
              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.month && { error: true })}
              >
                <InputLabel><RequiredLabel label="Month" /></InputLabel>
                <Select
                  label="Month"
                  name="month"
                  size="small"
                  value={values.month}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    wfMonths.map(
                      (month, index) => (<MenuItem key={index} value={month}>{month}</MenuItem>)
                    )
                  }
                </Select>
                {errors.month && <FormHelperText>{errors.month}</FormHelperText>}
              </FormControl>

              {/* Year field */}
              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.year && { error: true })}
              >
                <InputLabel><RequiredLabel label="Year" /></InputLabel>
                <Select
                  label="Year"
                  name="year"
                  size="small"
                  value={values.year}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {/* Keep explicit financial year option available */}
                  <MenuItem value="2025-2026">2025-2026</MenuItem>
                  {
                    yearOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                {errors.year && <FormHelperText>{errors.year}</FormHelperText>}
              </FormControl>

              {/* Display button */}
              <Button
                color="success"
                variant="contained"
                onClick={handleSubmit}
                sx={{ height: 40 }}
              >
                Display
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify}
      />
    </Box>
  )
}

export default WFStatementReport;

